<template>
    <div class="px-4 flex flex-col items-center justify-center h-full w-full py-6">
        <div class="flex flex-col items-center justify-center h-full">
            <div
                v-if="pinButtons"
                class="mt-auto"
            />
            <div v-if="icon">
                <UIIcon
                    :icon="icon"
                    class="text-gray-500"
                    :size="64"
                    weight="thin"
                />
            </div>
            <div
                class="text-md font-medium mt-6 mb-2 text-center"
                :style="{ color: titleColor }"
            >
                {{ title }}
            </div>
            <div class="text-sm text-gray-600 mb-8 text-center">
                {{ body }}
            </div>
            <div class="flex" />
            <!-- Apply full-width so buttons to can flex to the width of the content -->
            <div
                v-if="buttons?.length"
                class="flex flex-col items-center justify-center w-full space-y-3"
                :class="{ 'mt-auto': pinButtons }"
            >
                <DButton
                    v-for="(button, index) in buttons"
                    :key="index"
                    :theme="button.type"
                    :wide="button.flex"
                    :loading="submitting"
                    :right-icon="button.icon ? `ph:${button.icon}` : null"
                    @click="handleButton(button)"
                >
                    {{ button.title }}
                </DButton>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { useRouter } from 'vue-router'
    import { DButton } from '@digistorm/spark'
    import UIIcon from '@/components/ui/UIIcon.vue'

    const router = useRouter()
    const moduleHelpers = useModuleHelpers()

    const props = defineProps({
        config: Object,
    })

    const icon = ref(props.config.data.icon)
    const buttons = ref(props.config.data.buttons)
    const title = ref(props.config.data.title)
    const body = ref(props.config.data.body)
    const titleColor = ref(props.config.data.title_color)
    const pinButtons = ref(props.config.data.pin_buttons)

    const submitting = ref(false)

    const handleButton = (button) => {
        submitting.value = true

        return moduleHelpers.handleClick(router, button, null, false)
            .then((appModule) => {
                if (!appModule || !appModule.id) {
                    return
                }
                router.push({ name: 'view', params: { id: appModule.id } })
            })
            .catch((e) => {
                console.log('Failed to open link', e)
            })
            .finally(() => {
                submitting.value = false
            })
    }
</script>
